import React, {useContext, useState, useEffect, useRef} from 'react'
import { Button, Container, Divider, Grid, Header, Icon, Image, Message, Segment, Tab, Table, Menu, List, Accordion, Dimmer, Loader, Dropdown } from 'semantic-ui-react'
import {Slide} from 'react-slideshow-image'
import CharImg from './assets/images/char.png'
import GooglePlayImg from './assets/images/google-play-badge.svg'
import WindowsImg from './assets/images/pc-build-badge.svg'
import AppStoreImg from './assets/images/app-store.svg'
import SurveyImg from './assets/images/btn_survey.png'
import ChallengeImg from './assets/images/svg/challenge.svg'
import PrizeImg from './assets/images/svg/prizes.svg'
import ToCImg from './assets/images/svg/term.svg'
import { LangugageContext } from './LanguageContext'
import { formatDate } from './Helper'
import { toast } from 'react-toastify'

const HomePage = (props) =>{
    const {translation} = useContext(LangugageContext)
    const [activeIndex, setActiveIndex] = useState(0)
    const [hofLoading, setHofLoading] = useState(true)
    const [hof, setHof] = useState([])
    const [standing, setStanding] = useState([])
    const [standingLoading, setStandingLoading] = useState(true)
    const [standingDetail, setStandingDetail] = useState(null)
    const [timerComponents, setTimerComponents] = useState([])
    const [timerVideoComponents, setTimerVideoComponents] = useState([])
    const [statusTime, setStatusTime] = useState('')
    const [statusVideoTime, setStatusVideoTime] = useState('')
    const [currentTypeTab, setCurrentTypeTab] = useState('stars')
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const launch = useRef();
    const launchVideo = useRef();
    const currentEndDate = useRef()
    const currentEndDateVideo = useRef()
    const loadingCounter = useRef()
    const loadingCounterVideo = useRef()
    const [luckyDrawData, setLuckyDrawData] = useState([])
    const [ldLoading, setldLoading] = useState(true)
    const [selectedLD, setSelectedLD] = useState({})
    const [luckyDrawDetail, setluckyDrawDetail] = useState(null)
    const [ldDetailLoading, setLDDetailLoading] = useState(false)
    const [videoList, setVideoList] = useState(null)

    useEffect(() => {
        window.scrollTo(0, 0);
        loadHoF()
        loadStanding(props.event.current_id)
        loadLuckyDraw()
        return () => pauseCountDown()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const loadHoF = () =>{
        fetch(process.env.REACT_APP_DOC_URL+'hof.php')
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            setHof(res.result)
            setHofLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong on fetching Hall of fame data, please contact developer.')
        })
    }

    const generateTimeCountDown = (type, startDate, endDate) =>{
        pauseCountDown(type)
        let now = new Date()
        let start = new Date(startDate*1000)
        let end = new Date(endDate*1000)
        if(start > now){
            if(type === 'video'){
                currentEndDateVideo.current = new Date(start)
                setStatusVideoTime('not started')
            }else{
                currentEndDate.current = new Date(start)
                setStatusTime('not started')
            }

        }else{
            if(type === 'video'){
                currentEndDateVideo.current = new Date(end)

                if(now < end){
                    setStatusVideoTime('on progress')
                }else{
                    setStatusVideoTime('ended')
                }
            }else{
                currentEndDate.current = new Date(end)

                if(now < end){
                    setStatusTime('on progress')
                }else{
                    setStatusTime('ended')
                }
            }
        }

        startCountDown(type)
    }

    const loadLuckyDraw = () =>{
        fetch(process.env.REACT_APP_CRM_URL+'api/game/ldvideo/get_lucky_draw')
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            let data = []
            res.data.forEach(x=>{
                data.push({
                    key: x.lucky_draw_id,
                    value: x.lucky_draw_id,
                    text: x.lucky_draw_name_date+' ('+x.status+')',
                    name: x.lucky_draw_name,
                    start: x.date_start,
                    end: x.date_end
                })
            })

            generateTimeCountDown('video', data[0].start, data[0].end)

            setLuckyDrawData(data)
            setSelectedLD(data[0])
            loadLuckyDrawDetail(data[0].value)
            setldLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong on fetching lucky draw data, please contact developer.')
        })
    }

    const loadLuckyDrawDetail = (id) =>{
        setLDDetailLoading(true)
        fetch(process.env.REACT_APP_CRM_URL+'api/game/ldvideo/getvideos/'+id)
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            if(res.done){
                let data = res.data
                setluckyDrawDetail(data)
                let videos = {}
                if(data.videos.length > 0){
                    videos.active = data.videos[0]
                    let newVideoFormat = []
                    let idx = 1
                    data.videos.forEach(x=>{
                        let id = x.url.split('/')
                        newVideoFormat.push({
                            id: idx,
                            title: x.title,
                            url: x.url,
                            info: x.info,
                            image: 'https://img.youtube.com/vi/'+id[id.length-1]+'/hqdefault.jpg',
                            active: false
                        })

                        idx++
                    })
                    newVideoFormat[0].active = true
                    videos.other = newVideoFormat
                }
                setVideoList(videos)
            }else{
                setVideoList(null)
                setluckyDrawDetail(null)
            }
            setLDDetailLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong on fetching lucky draw detail data, please contact developer.')
        })
    }

    const LDChange = (e, data) =>{
        loadingCounterVideo.current = true
        let selected = data.options.filter(x=>x.value === data.value)[0]
        setSelectedLD(selected)
        loadLuckyDrawDetail(data.value)
        generateTimeCountDown('video', selected.start, selected.end)
    }

    const loadStanding = (id, e=null) =>{
        loadingCounter.current = true
        if(!standingLoading) setStandingLoading(true)
        fetch(process.env.REACT_APP_DOC_URL+'getChallengeHighScore.php?event_id='+id)
        .then((res)=>{
            return res.json()
        })
        .then((res)=>{
            setStanding(res.data)
            
            let challengeType = "Star-Catcher";
            setActiveTabIndex(0)
            if(res.type === "friends"){
                challengeType = "Popular Mayor";
                setActiveTabIndex(2)
            }else if(res.type === "scores"){
                challengeType = "Top Scorer";
                setActiveTabIndex(1)
            }else if(res.type === "ticket"){
                challengeType = "Learning Frenzy";
                setActiveTabIndex(3)
            }else if(res.type === "superticket"){
                setActiveTabIndex(4)
                challengeType = "SUPER Learning Frenzy";
            }

            let standDetail = {
                end: res.end,
                eventDate: formatDate(new Date(res.start*1000)) +' - '+formatDate(new Date(res.end*1000))+' WIB ('+challengeType+')',
                start: res.start,
                type: res.type,
                number_of_winner: res.number_of_winner
            }

            generateTimeCountDown('leaderboard', res.start, res.end)
            setStandingDetail(standDetail)
            setStandingLoading(false)
        })
        .catch((e)=>{
            toast.error('Something wrong on fetching leaderboard, please contact developer.')
        })
    }

    const handleClick = (e, titleProps) => {
        const { index } = titleProps
        const newIndex = activeIndex === index ? -1 : index
    
        setActiveIndex(newIndex)
    }

    const startCountDown = (type) => {
        if(type === 'leaderboard'){
            clearInterval(launch.current)
            launch.current = setInterval(function() { calculateTimeLeft('leaderboard'); }, 1000);
        }else{
            clearInterval(launchVideo.current)
            launchVideo.current = setInterval(function() { calculateTimeLeft('video'); }, 1000);
        }
    };

    const pauseCountDown = (type='all') => {
        if(type === 'all'){
            clearInterval(launch.current);
            clearInterval(launchVideo.current);
        }else if(type === 'leaderboard'){
            clearInterval(launch.current);
        }else{
            clearInterval(launchVideo.current);
        }
    };


    const calculateTimeLeft = (type) => {
        if(type === 'video'){
            loadingCounterVideo.current = false
        }else{
            loadingCounter.current = false
        }
        let difference = type === 'leaderboard' ? +currentEndDate.current - +new Date() : +currentEndDateVideo.current - +new Date();
        let timeLeft = {};
    
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };

            let tc = []

            Object.keys(timeLeft).forEach((interval) => {
                tc.push(timeLeft[interval]);
            });

            if(type === 'video'){
                setTimerVideoComponents(tc)
            }else{
                setTimerComponents(tc)
            }
        }else{
            pauseCountDown(type)
            if(type === 'video'){
                setTimerVideoComponents([])
            }else{
                setTimerComponents([])
            }
        }
    }

    const generateTabContent = () =>{
        let types = ["stars", "scores", "friends", "ticket", "superticket"]
        let components = []
        types.forEach(x=>{
            let typeText = 'Star-Catcher'
            let iconName = 'star'
            if(x === 'scores'){
                typeText = 'Top Scorer'
                iconName = 'trophy'
            }else if(x === 'friends'){
                typeText = 'Popular Mayor'
                iconName = 'users'
            }else if(x === 'ticket'){
                typeText = 'Learning Frenzy'
                iconName = 'diamond'
            }else if(x === 'superticket'){
                typeText = 'Super Learning Frenzy'
            }
            components.push({ menuItem: (
                <Menu.Item key={x}>
                    {x !== 'superticket' ? <Icon name={iconName}/> : <Icon.Group>
                        <Icon name="diamond"/>
                        <Icon name="add" corner="bottom left"/>
                    </Icon.Group>} {typeText}
                </Menu.Item>
              ), render: () => 
                <>
                <Divider hidden/>
                <Segment padded="very">
                    <Grid columns="equal" className="tabGrid">
                        <Grid.Row>
                        <Grid.Column width="10">
                            <Header as="h1" className="segmentTitle" color="orange">{translation.the_challenge}</Header>
                            <p>{translation['theChallenge_'+x]}</p>
                            <Divider hidden/>
                            <iframe title="doc" width="100%" height="315" src="https://www.youtube.com/embed/61X-4YB831w"
                            frameBorder="0" allowFullScreen>
                            </iframe>
                        </Grid.Column>
                        <Grid.Column>
                            <Image src={ChallengeImg}/>
                        </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
                </>
            })
        })

        return components
    }

    const onTabChange = (e, data) =>{
        setActiveTabIndex(data.activeIndex)
        setCurrentTypeTab(data.panes[data.activeIndex].menuItem.key)
    }

    const generatePrizeSection = () =>{
        let comps = null
        if(translation['prizes_'+currentTypeTab] !== undefined){
            let data = translation['prizes_'+currentTypeTab]
            let temp = []
            data = data.split(' ||| ')
            data = data[1].split(" | ")
            let i = 0
            data.forEach(x=>{
                temp.push(<List.Item key={'prize_'+i}>{x}</List.Item>)
                i++
            })
            comps = <List ordered key="prizes">
                {temp}
            </List>
        }

        return comps
    }

    const generateFAQSection = () =>{
        let comps = null
        if(translation['faq_'+currentTypeTab] !== undefined){
            let data = translation['faq_'+currentTypeTab]
            let temp = []
            data = data.split(' ||| ')
            let i = 0
            data.forEach(x=>{
                let dataContent = x.split(" | ")
                temp.push(<div key={'faq_'+i}>
                <Accordion.Title
                active={activeIndex === i}
                index={i}
                onClick={handleClick}
                >
                <Icon name='dropdown' />
                {dataContent[0]}
                </Accordion.Title>
                <Accordion.Content active={activeIndex === i}>
                <p>{dataContent[1]}</p>
                </Accordion.Content>
                </div>)
                i++
            })
            comps = <Accordion fluid styled key="faq">
                {temp}
            </Accordion>
        }

        return comps
    }

    const generateTOCSection = () =>{
        let comps = null
        if(translation['toc_'+currentTypeTab] !== undefined){
            let data = translation['toc_'+currentTypeTab]
            let temp = []
            data = data.split(" | ")
            let i = 0
            data.forEach(x=>{
                temp.push(<List.Item key={'toc_'+i}>{x}</List.Item>)
                i++
            })
            comps = <List ordered key="toc">
                {temp}
            </List>
        }

        return comps
    }

    const changeVideo = (data, e) =>{
        setLDDetailLoading(true)
        let video = videoList
        let vid = video.other.findIndex(x=>x.active)
        video.other[vid].active = false
        let vid2 = video.other.findIndex(x=>x.id === data.id)
        video.other[vid2].active = true
        video.active = data
        setVideoList(video)
        setTimeout(()=>{
            setLDDetailLoading(false)
        }, 500)
    }

    return(
        <div id="home_page">
            <section id="home_banner">
                <Segment basic className="banner">
                    <Container>
                        <Grid columns="equal" id="banner_grid">
                            <Grid.Row>
                                <Grid.Column width="7">
                                    <Image src={CharImg} size="large"/>
                                </Grid.Column>
                                <Grid.Column>
                                    <Header as="h1" textAlign="right" inverted id="mainTitle">{translation.weekly}</Header>
                                    <Header as="h2" inverted textAlign="right" id="subTitle">{translation.weeklySub}</Header>
                                    <Image.Group size="small" className="rightAlign">
                                        <Image as="a" href={props.installer} 
                                        target="_blank" src={WindowsImg}/>
                                        <Image as="a" href={props.event.linkText2.includes('http') ? props.event.linkText2 : 'https://'+props.event.linkText2}
                                        target="_blank" src={SurveyImg}/>
                                    </Image.Group>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Container>
                </Segment>
            </section>
            <section id="home_hof">
                <Segment basic>
                    <Container>
                        <Header as="h1" inverted className="segmentTitle">
                            <Icon name="trophy" color="orange"/> Hall of Fame
                        </Header>
                        <Segment basic>
                            <Slide easing="ease" autoplay={false}>
                                {hof.map((v, k)=>
                                <Container textAlign="center" className="each-slide" key={k}>
                                    <div className="hof_item">
                                        <Image circular src={v.Photo_URL}/>
                                        <div className="testimoni">
                                            <p><Icon name="quote left"/> {translation['HOF'+v.User_ID] === undefined ? v.Description : translation['HOF'+v.User_ID]}</p>
                                            <i>– {v.Name}, {v.Location}</i>
                                        </div>
                                    </div>
                                </Container>
                                )}
                            </Slide>
                            <Dimmer active={hofLoading}>
                                <Loader active size="large"/>
                            </Dimmer>
                        </Segment>
                    </Container>
                </Segment>
            </section>
            <section id="home_leaderboard">
                <Segment basic className="leaderboard_wrap">
                    <Container>
                        <Grid columns="equal" id="grid_leaderboard">
                            <Grid.Column width="10">
                                <Segment padded="very">
                                    <Header as="h1" className="segmentTitle" color="orange">{translation.standings}</Header>
                                    <Divider hidden/>
                                    <Grid columns="equal" className="eventGrid">
                                        <Grid.Row>
                                            <Grid.Column width="14">
                                                <Header as="h3">{standingDetail !== null ? standingDetail.eventDate : '-'}</Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Button icon color="orange" onClick={loadStanding.bind(null, props.event.current_id)}>
                                                    <Icon name="refresh"/>
                                                </Button>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>

                                    <Divider hidden/>

                                    <Table basic="very" id="standingTable">
                                        <Table.Body>
                                            {standing.length > 0 ? 
                                            standing.map((v, k)=>
                                            <Table.Row key={k}>
                                                <Table.Cell>#{v.Rank}</Table.Cell>
                                                <Table.Cell>{v.Chat_Name} ({v.User_Name})</Table.Cell>
                                                <Table.Cell textAlign="right">{v.Stars}</Table.Cell>
                                            </Table.Row>
                                            )
                                            : 
                                            <Table.Row>
                                                <Table.Cell>
                                                <Message>
                                                {statusTime === 'not started' ? translation.noPlayerData2 : statusTime === 'on progress' ? translation.noPlayerData : translation.noActiveCompetition}
                                                </Message>
                                                </Table.Cell>
                                            </Table.Row>
                                            }
                                        </Table.Body>
                                    </Table>
                                    {standingDetail !== null ? 
                                    <Message warning size="mini" className="surveryWarning">{translation['surveyWarning_'+standingDetail.type]}</Message>
                                    : null}
                                    <Dimmer active={standingLoading}>
                                        <Loader active/>
                                    </Dimmer>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment padded="very">
                                    <Header as="h1" className="segmentTitle" color="orange">{translation.countdown}</Header>
                                    <Divider hidden/>
                                    {timerComponents.length ? <div className="counterWrap">
                                        <div className="countNumber">{timerComponents[0]}</div>
                                        <div className="countDesc">{translation.d}</div>
                                        <div className="countNumber">{timerComponents[1]}</div>
                                        <div className="countDesc">{translation.h}</div>
                                        <div className="countNumber">{timerComponents[2]}</div>
                                        <div className="countDesc">{translation.m}</div>
                                        <div className="countNumber">{timerComponents[3]}</div>
                                        <div className="countDesc">{translation.s}</div>
                                    </div> : <div className="counterWrap">
                                        <div className="countNumber">0</div>
                                        <div className="countDesc">{translation.d}</div>
                                        <div className="countNumber">0</div>
                                        <div className="countDesc">{translation.h}</div>
                                        <div className="countNumber">0</div>
                                        <div className="countDesc">{translation.m}</div>
                                        <div className="countNumber">0</div>
                                        <div className="countDesc">{translation.s}</div>
                                    </div>}
                                    <Divider hidden/>
                                    <span className="untilCount">{statusTime === 'not started' ? translation.untilCount2 : statusTime === 'on progress' ? translation.untilCount : translation.untilCount3}</span>
                                    <Dimmer active={standingLoading || loadingCounter.current}>
                                        <Loader active/>
                                    </Dimmer>
                                </Segment>
                            </Grid.Column>
                        </Grid>
                    </Container>
                </Segment>
                
            </section>
            <Segment basic className="banner" id="segmentChallenge">
                <Container>
                    <section id="home_challenge">
                        <Tab menu={{ pointing: true, fluid: true, className: 'five item' }}  
                        onTabChange={onTabChange} panes={generateTabContent()} activeIndex={activeTabIndex}/>
                    </section>
                    <Divider hidden/>
                    <section id="home_prizes">
                        <Segment padded="very">
                            <Container>
                                <Grid columns="equal" className="prizeGrid">
                                    <Grid.Row>
                                        <Grid.Column width="6">
                                            <Image src={PrizeImg}/>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="h1" className="segmentTitle" color="orange">{translation.prizes}</Header>
                                            {generatePrizeSection()}
                                            <p>{translation.follow_us}</p>
                                            <div className="socialWrap">
                                                <a rel="noreferrer" href="https://www.facebook.com/solveeducation/" target="_blank" className="ui mini icon facebook button"><Icon name="facebook"/></a>
                                                <a rel="noreferrer" href="https://twitter.com/solveeducation" target="_blank" className="ui mini icon twitter button"><Icon name="twitter"/></a>
                                                <a rel="noreferrer" href="https://www.linkedin.com/company/solve-education-/" target="_blank" className="ui mini icon linkedin button"><Icon name="linkedin"/></a>
                                                <a rel="noreferrer" href="https://www.instagram.com/solveeducation/" target="_blank" className="ui mini icon instagram button"><Icon name="instagram"/></a>
                                                <a rel="noreferrer" href="https://www.youtube.com/channel/UCXFFHqO7BzyiaG1qt8MBhlg" target="_blank" className="ui mini icon youtube button"><Icon name="youtube"/></a>
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        </Segment>
                    </section>
                    <Divider hidden/>
                    <section id="home_tc">
                        <Segment padded="very">
                            <Container>
                                <Grid columns="equal" className="TOC">
                                    <Grid.Column width="10">
                                        <Header as="h1" className="segmentTitle" color="orange">{translation.toc}</Header>
                                        {generateTOCSection()}
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Image src={ToCImg}/>
                                    </Grid.Column>
                                </Grid>
                            </Container>
                        </Segment>
                    </section>
                    <Divider hidden/>
                    <section id="home_faq">
                        <Segment padded="very">
                            <Container>
                                <Grid columns="equal" className="prizeGrid">
                                    <Grid.Row>
                                        <Grid.Column width="6">
                                            <Image src={PrizeImg}/>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header as="h1" className="segmentTitle" color="orange">{translation.faqs}</Header>
                                            {generateFAQSection()}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Container>
                        </Segment>
                    </section>
                </Container>
            </Segment>

            <section id="ld_video">
                <Segment basic className="leaderboard_wrap">
                    {ldLoading ? <Loader active/> : 
                    luckyDrawData.length > 0 ? 
                    <Container>
                        <Grid columns="equal" id="grid_luckydraw">
                            <Grid.Row>
                                <Grid.Column textAlign="center">
                                    <Dropdown search selection options={luckyDrawData} 
                                    value={selectedLD.value} onChange={LDChange}
                                    loading={ldLoading || ldDetailLoading} disabled={ldLoading || ldDetailLoading}/>
                                    <Header as="h1">{selectedLD.name}</Header>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row id="ld_countdown">
                                <Grid.Column/>
                                <Grid.Column width={10}>
                                    <Segment padded="very">
                                        <Header as="h1" textAlign="center" className="segmentTitle" color="orange">{translation.countdown}</Header>
                                        <Divider hidden/>
                                        {timerVideoComponents.length ? <div className="counterWrap">
                                            <div className="countNumber">{timerVideoComponents[0]}</div>
                                            <div className="countDesc">{translation.d}</div>
                                            <div className="countNumber">{timerVideoComponents[1]}</div>
                                            <div className="countDesc">{translation.h}</div>
                                            <div className="countNumber">{timerVideoComponents[2]}</div>
                                            <div className="countDesc">{translation.m}</div>
                                            <div className="countNumber">{timerVideoComponents[3]}</div>
                                            <div className="countDesc">{translation.s}</div>
                                        </div> : <div className="counterWrap">
                                            <div className="countNumber">0</div>
                                            <div className="countDesc">{translation.d}</div>
                                            <div className="countNumber">0</div>
                                            <div className="countDesc">{translation.h}</div>
                                            <div className="countNumber">0</div>
                                            <div className="countDesc">{translation.m}</div>
                                            <div className="countNumber">0</div>
                                            <div className="countDesc">{translation.s}</div>
                                        </div>}
                                        <Divider hidden/>
                                        <span className="untilCount">{statusVideoTime === 'not started' ? translation.untilCount2 : statusVideoTime === 'on progress' ? 'until current lucky draw ends.' : 'The lucky draw is ended.'}</span>
                                        <Dimmer active={ldLoading || loadingCounterVideo.current}>
                                            <Loader active/>
                                        </Dimmer>
                                    </Segment>
                                </Grid.Column>
                                <Grid.Column/>
                            </Grid.Row>
                            {luckyDrawDetail !== null ? 
                            <>
                            <Divider hidden/>
                            <Divider hidden/>
                            <Divider hidden/>
                            <Grid.Row id="videoListRow">
                                <Dimmer active={ldDetailLoading}>
                                    <Loader active={ldDetailLoading}>Loading...</Loader>
                                </Dimmer>
                                
                                {videoList !== null ? 
                                <>
                                <Grid.Column textAlign="center" width={16}>
                                    <Header as="h1">{videoList.active.title}</Header>
                                    <iframe title="doc" width="70%" height="315" src={videoList.active.url}
                                    frameBorder="0" allowFullScreen>
                                    </iframe>
                                    <Divider hidden/>
                                    <Header as="h3">{videoList.active.info}</Header>
                                    <Divider hidden/>
                                    <Divider hidden/>
                                </Grid.Column>
                                <Grid.Column textAlign="center" width={16}>
                                    <Slide easing="ease" autoplay={false} slidesToScroll={4} slidesToShow={4} id="videoList" 
                                    canSwipe={false} infinite={false}>
                                        {videoList.other.map((v, k)=>
                                        <Segment key={k} className={v.active ? 'active' : null} onClick={changeVideo.bind(null, v)}>
                                            {v.active ? 
                                            <Dimmer active>
                                            <Header as='h2' icon inverted>
                                                <Icon name='check' />
                                            </Header>
                                            </Dimmer>
                                            : <Icon name='play circle'/>}
                                            <Image src={v.image} size="medium"/>
                                        </Segment>
                                        )}
                                    </Slide>
                                </Grid.Column>
                                </>
                                
                                : null}
                            </Grid.Row>
                            </>
                            : null}
                        </Grid>
                    </Container>
                    :
                    <Header as="h1" textAlign="center">No ongoing lucky draws</Header>
                    }
                </Segment>
            </section>
        </div>
    )
}

export default HomePage
